<template>
  <span>
    <slot :text="dictText">
      {{dictText}}
    </slot>
  </span>
</template>

<script>
export default {
  name: "DictText",
  props: {
    dictFlag: {
      type: String,
      default: ""
    },
    status: {
      type: [String, Number],
      default: ""
    }
  },
  data() {
    return {

    }
  },
  computed: {
     dictList() {
      if(!this.dictFlag) return [];
       return this.$store.getters.getDictByFlag(this.dictFlag);
    },
    dictText() {
      const text = this.dictList.find(item => item.dictValue == this.status)?.name || this.status;
      return this.$t(text);
    }
  },
}
</script>

<style scoped>

</style>
